// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LL8Hs0yt0t4SGZNm8f09,
.F0m_fmxmO4VcFMRXmuon {
  width: 100%;
  height: 36px;
  margin: 10px 0;
  font-weight: 100;
  font-size: 16px;
  font-family: PremierLeague-Light, sans-serif;
  border: none;
  border-radius: 12px;
}

.F0m_fmxmO4VcFMRXmuon {
  padding: 20px;
  font-size: 16px;
}
.F0m_fmxmO4VcFMRXmuon:focus {
  outline: none;
}

.LL8Hs0yt0t4SGZNm8f09,
.LL8Hs0yt0t4SGZNm8f09:active,
.LL8Hs0yt0t4SGZNm8f09:focus {
  background-color: #e2407e !important;
  border: solid 1px #e2407e !important;
}

.LL8Hs0yt0t4SGZNm8f09:hover {
  background-color: rgb(72.6889483066%, 11.0365418895%, 34.6319073084%);
  border: solid 1px rgb(72.6889483066%, 11.0365418895%, 34.6319073084%);
}

.LL8Hs0yt0t4SGZNm8f09:disabled {
  background-color: rgb(64.0071301248%, 9.7183600713%, 30.495543672%);
  border: solid 1px rgb(64.0071301248%, 9.7183600713%, 30.495543672%);
}

.EPXaTWCxxeypdiq_vCD1 {
  color: #e2407e !important;
  font-size: 11px !important;
  text-align: left !important;
}

.nBnYRLamI2YdSdlfxYns {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  color: #fff !important;
  font-size: 16px;
}
.nBnYRLamI2YdSdlfxYns svg {
  margin-right: 10px;
}

@media only screen and (max-width: 576px) {
  .LL8Hs0yt0t4SGZNm8f09,
  .F0m_fmxmO4VcFMRXmuon {
    height: 45px;
    font-size: 17px;
  }
}`, "",{"version":3,"sources":["webpack://./js/view/page/login/component/form/styles.scss"],"names":[],"mappings":"AAAA;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,4CAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;;;EAGE,oCAAA;EACA,oCAAA;AAAF;;AAGA;EACE,qEAAA;EACA,qEAAA;AAAF;;AAGA;EACE,mEAAA;EACA,mEAAA;AAAF;;AAGA;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AAAF;AAEE;EACE,kBAAA;AAAJ;;AAIA;EACE;;IAEE,YAAA;IACA,eAAA;EADF;AACF","sourcesContent":[".submit_button,\n.fields {\n  width: 100%;\n  height: 36px;\n  margin: 10px 0;\n  font-weight: 100;\n  font-size: 16px;\n  font-family: PremierLeague-Light, sans-serif;\n  border: none;\n  border-radius: 12px;\n}\n\n.fields {\n  padding: 20px;\n  font-size: 16px;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.submit_button,\n.submit_button:active,\n.submit_button:focus {\n  background-color: #e2407e!important;\n  border: solid 1px #e2407e!important;\n}\n\n.submit_button:hover {\n  background-color: darken(#e2407e, 15%);\n  border: solid 1px darken(#e2407e, 15%);\n}\n\n.submit_button:disabled {\n  background-color: darken(#e2407e, 20%);\n  border: solid 1px darken(#e2407e, 20%);\n}\n\n.error_message {\n  color: #e2407e !important;\n  font-size: 11px !important;\n  text-align: left !important;\n}\n\n.back_link {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 10px;\n  color: #fff !important;\n  font-size: 16px;\n\n  svg {\n    margin-right: 10px;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .submit_button,\n  .fields {\n    height: 45px;\n    font-size: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submit_button": `LL8Hs0yt0t4SGZNm8f09`,
	"fields": `F0m_fmxmO4VcFMRXmuon`,
	"error_message": `EPXaTWCxxeypdiq_vCD1`,
	"back_link": `nBnYRLamI2YdSdlfxYns`
};
export default ___CSS_LOADER_EXPORT___;
